export default "__VITE_ASSET__B6_0Cn85__"